import {useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {resetDocumentScroll} from '../lib/navigation/scrollRestoration';

function ScrollToTop() {
  const {pathname} = useLocation();

  useLayoutEffect(() => {
    resetDocumentScroll();
  }, [pathname]);

  return null;
}

export default ScrollToTop;
